import { usePagination } from 'react-instantsearch';

import { Pagination as NormalPagination } from '@/molecules';

import type { FunctionComponent } from 'react';
import type { TypePaginationProps } from './types';

/**
 * Pagination
 */
export const Pagination: FunctionComponent<TypePaginationProps> = ({
  className = '',
  pageRangeDisplayed,
}: TypePaginationProps) => {
  const { nbPages, refine } = usePagination();
  const p = Array(nbPages).fill(null);

  return (
    <NormalPagination
      pageRangeDisplayed={pageRangeDisplayed}
      pageCount={p.length}
      className={className}
      onPageChange={(page) => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        refine(page.selected);
      }}
    />
  );
};

Pagination.displayName = 'Pagination';
